import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#121212] border-t border-white/25 py-16 px-[7.6923%]">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_lynqnext-landing/artifacts/z485gwgx_Final%20Logo.jpg" 
              alt="LYNQnext Consulting" 
              className="h-12 object-contain mb-6"
              style={{
                mixBlendMode: 'screen',
                filter: 'brightness(1.1) contrast(1.05)'
              }}
            />
            <p className="text-white/85 text-base leading-relaxed">
              Empowering SMEs with strategic digital and martech solutions for transformative growth
            </p>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="text-xl font-semibold text-white mb-6">Contact Information</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin className="text-[#00FFD1] mt-1 flex-shrink-0" size={20} />
                <p className="text-white/85 text-base leading-relaxed">
                  {contactInfo.address}
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="text-[#00FFD1] flex-shrink-0" size={20} />
                <a 
                  href={`tel:${contactInfo.phone}`}
                  className="text-white/85 text-base hover:text-[#00FFD1] transition-colors duration-300"
                >
                  {contactInfo.phone}
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="text-[#00FFD1] flex-shrink-0" size={20} />
                <a 
                  href={`mailto:${contactInfo.email}`}
                  className="text-white/85 text-base hover:text-[#00FFD1] transition-colors duration-300"
                >
                  {contactInfo.email}
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-semibold text-white mb-6">Quick Links</h3>
            <nav className="space-y-3">
              <button 
                onClick={() => document.getElementById('home').scrollIntoView({ behavior: 'smooth' })}
                className="block text-white/85 text-base hover:text-[#00FFD1] transition-colors duration-300 text-left"
              >
                Home
              </button>
              <button 
                onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
                className="block text-white/85 text-base hover:text-[#00FFD1] transition-colors duration-300 text-left"
              >
                About Us
              </button>
              <button 
                onClick={() => document.getElementById('clients').scrollIntoView({ behavior: 'smooth' })}
                className="block text-white/85 text-base hover:text-[#00FFD1] transition-colors duration-300 text-left"
              >
                Our Clients
              </button>
              <button 
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                className="block text-white/85 text-base hover:text-[#00FFD1] transition-colors duration-300 text-left"
              >
                Contact Us
              </button>
            </nav>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-white/25 text-center">
          <p className="text-white/60 text-base">
            © {currentYear} LYNQnext Consulting Private Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
